module.exports = __webpack_public_path__ + "static/tiger-66623a9db6089ceb48c58c9a6c816be5.png";